module.exports = __webpack_public_path__ + "img/image11.7fee8433.png";